document.addEventListener("DOMContentLoaded", function() {
    // Back to top button
    let toTopButton = document.getElementById("back-top-btn");
    window.onscroll = function() {scrollFunction()};

    function scrollFunction() {
        console.log(document.body.scrollTop);
        if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
            toTopButton.style.display = "block";
        } else {
            toTopButton.style.display = "none";
        }
    }

   toTopButton.addEventListener('click', function() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
   }, false);
});